export enum ContactRequestFilterType {
  ALL = 'ALL',
  SENT = 'SENT',
  RECEIVED = 'RECEIVED',
}

export enum ContactRequestFilterStatus {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED',
}

